import {
  Alert,
  Box,
  Container,
  List,
  ListItem,
  ListItemText,
  Paper,
  Skeleton,
  Stack,
  Tab,
  Tabs,
  Typography,
  Button,
  Link,
  TextField,
  ImageList,
  ImageListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  Card,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import redirectFill from "@iconify/icons-eva/arrow-back-fill";
import {
  getImage,
  reportIssuesList,
  socketTypeList,
  formatNumber,
} from "../../../util/Display";
import React, { useContext, useEffect, useRef, useState, Fragment } from "react";
import { useParams, useLocation } from "react-router-dom";
import Constant from "../../../util/constants";
import Page from "../../Page";
import MarkerInformationTab from "../MarkerInformationTab";
import { StripeCheckout } from "./StripeCheckout";
import { PaymentForm } from "./PaymentForm";
import { PaymentStatusContainer } from "./PaymentStatusContainer";
import { paymentStyles } from "./payment.constants";
import { useCharger } from "../../../react-query/hooks/useCharger";
import { EmailComponent } from "./EmailComponent";
import { Context } from "../../../context";
import { is } from "../../../util/is";
import styled from "@emotion/styled";
import { LoadingButton } from "@mui/lab";
import { ReactComponent as CallUs } from "../../../image/chargerStationIcons/callUs.svg";
import { Icon } from "@iconify/react";
import axios from "axios";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import ChargemilesLogo from "../../../image/networkFilter/Chargemiles.png";

import { useTheme } from "@emotion/react";
import { MuiSnackBar } from "../../@material-extend";
import Token from "../../../util/Token";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import { useDomainConfig } from "../../../hooks/useDomainConfig";

const { imageMapper } = Constant;

export const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  fontSize: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    fontSize: "13px",
  },
}));

const StyledChargerTabs = styled(Tabs)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  borderRadius: 8,
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${(theme.palette.grey || {})[50] || '#fafafa'} 100%)`,
  padding: theme.spacing(0.75),
  boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.05)}`,
  border: `1px solid ${alpha(theme.palette.primary.light, 0.2)}`,
  overflow: 'hidden',
  boxSizing: 'border-box',
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(0.5),
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

const StyledChargerTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: 'transparent',
  borderRadius: 8,
  fontWeight: 700,
  textTransform: 'none',
  minHeight: 44,
  flex: '1 1 auto',
  minWidth: 0,
  margin: theme.spacing(0.25),
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.main,
  },
  '&.Mui-selected': {
    color: 'white',
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.4)}`,
    '&:hover': {
      background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
    },
  },
}));

const IssueButton = styled(Button)(({ theme }) => ({
  borderRadius: "10px",
  width: "100%",
}));

const a11yProps = (index) => {
  return {
    id: `charger-station-simple-tab-${index}`,
  };
};
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const getPriceDisplay = (item, domainConfig) => {
  if (item.priceType === "min" && item.priceperMin) {
    return `${formatNumber(item.priceperMin * 60, {
      style: "currency",
      currency: domainConfig.currency,
    })} per hour`;
  }

  if (item.priceperKW) {
    return `${formatNumber(item.priceperKW, {
      style: "currency",
      currency: domainConfig.currency,
    })} per KW`;
  }

  return "N/A";
};

export const ChargerInformation = ({ locationDetail }) => {
  const params = useParams();
  const location = useLocation();
  const domainConfig = useDomainConfig();
  const chargerId = params.chargerId;
  const connectorId = params.connectorId;
  const {
    data: charger,
    isFetching,
    isError,
    error,
  } = useCharger(chargerId, location.search, { 
    refetchInterval: (data, query) => (query?.state?.error ? false : 5000) 
  });
  
  const getStatusColor = (status, theme) => {
    const s = status?.toUpperCase();
    if (s === "AVAILABLE" || s === "PREPARING") return theme.palette.success.main;
    if (s === "CHARGING" || s === "SUSPENDEDEV" || s === "SUSPENDEDEVSE" || s === "FINISHING" || s === "IN USE") return theme.palette.warning.main;
    if (s === "FAULTED" || s === "OFFLINE" || s === "UNAVAILABLE") return theme.palette.error.main;
    return theme.palette.grey[500]; // default dull grey for unknown
  };
  // const { data: connectors = [1, 2] } = useLiveConnectors(chargerId);
  const { user } = useContext(Context);
  const [isGuest, setGuest] = useState(false);
  const [email, setEmail] = useState("");
  // const [customerName, setCustomerName] = useState("");
  const [clientId, setClientId] = useState("");
  const [value, setValue] = useState(0);
  const [connector, setConnector] = useState();
  // Holds the last-known effective connector ID so it survives the connector
  // state reset that happens when charger polling detects CHARGING status.
  const connectorIdForStatus = useRef(null);
  const [showCardInfo, setShowCardInfo] = useState(false);
  const [showConnectorMsg, setShowConnectorMsg] = useState(false);
  const [chargerInfo, setChargerInfo] = useState({});
  const [reportIssue, setReportIssue] = useState(false);
  const [chargerData, setChargerData] = useState();
  const [networkFilters, setNetworkFilter] = useState([]);
  const [reportIssueData, setReportIssueData] = useState({
    issue: "",
    message: "",
    otherIssue: false,
    category: "",
  });
  const [faqData, setFaqData] = useState();
  const [reportStat, setReportStat] = useState({
    open: false,
    variant: "",
    message: "",
  });
  const [photoModal, setPhotoModal] = useState({ open: false, src: "" });
  const domain = domainConfig?.domain?.toLowerCase();

  const handleChange = (_, newValue) => {
    setReportIssue(false);
    setValue(newValue);
  };
  const [paymentStatus, setPaymentStatus] = useState({
    isDone: false,
    status: false,
    message: "",
  });

  const clientHandler = (showCardInfo, clientId) => {
    clientId && setClientId(clientId);
    setShowCardInfo(showCardInfo);
  };

  useEffect(() => {
    if (charger && charger.amenities) {
      let amenities = charger.amenities.split(",");
      chargerInfo.amenities = amenities || [];
      setChargerInfo(chargerInfo);
    }

    if (
      charger &&
      charger?.connectors?.length > 0 &&
      charger.status?.toUpperCase() === "A"
    ) {
      charger.connectors.forEach((conn) => {
        if (
          conn?.connector_id === parseInt(connectorId) &&
          (conn?.status.toUpperCase() === "AVAILABLE" ||
            conn?.status.toUpperCase() === "PREPARING")
        ) {
          setConnector(conn);
        }
      });
    }
  }, [charger, connectorId]);

  // Handle deselecting connector if it becomes unavailable during polling
  useEffect(() => {
    if (connector && charger) {
      const resetConnectorState = () => {
        setConnector(null);
        setShowConnectorMsg(false);
        setGuest(false);
        setShowCardInfo(false);
        setPaymentStatus({
          isDone: false,
          status: false,
          message: "",
        });
      };

      if (charger.status?.toUpperCase() !== "A") {
        resetConnectorState();
        return;
      }
      const updatedConn = charger.connectors?.find((c) => c.connector_id === connector.connector_id) 
                       || charger.evses?.find((e) => e.evse_id === connector.evse_id);
                       
      if (updatedConn && updatedConn.status?.toUpperCase() !== "AVAILABLE" && updatedConn.status?.toUpperCase() !== "PREPARING") {
        resetConnectorState();
      }
    }
  }, [charger]);

  useEffect(() => {
    if (connector) {
      connectorIdForStatus.current = !is.empty(connector?.ocpi_connector_id)
        ? connector?.ocpi_connector_id
        : connector?.connector_id;
    }
  }, [connector]);

  useEffect(() => {
    setEmail(user?.userDetail?.email || "");
  }, [user]);

  useEffect(() => {
    const getFaqData = async (chargerBoxId) => {
      let baseUrl = `${process.env.REACT_APP_CHARGEMILES_CMS_END_POINT}/v1/charger/${chargerBoxId}/faq`;
      try {
        let response = await axios(`${baseUrl}`, { method: "get" });
        if (response.status === 200) {
          let faq = response.data.faqs;
          setFaqData(faq);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (charger?.chargepoint_id) {
      getFaqData(charger.chargepoint_id);
    } else return;
  }, [charger]);

  useEffect(() => {
    const fetchData = async () => {
      let baseUrl = `${process.env.REACT_APP_API_END_POINT}v2/location/get-detail`;
      baseUrl = `${baseUrl}?id=${charger.portalId}`;
      try {
        let response = await axios(`${baseUrl}`, { method: "get" });
        if (response.data.data) {
          setChargerData(response.data.data);
        }
      } catch (error) {
        console.error(error.response);
      }
    };

    if (charger?.portalId) {
      fetchData();
    } else return;
  }, [charger?.portalId]);

  useEffect(() => {
    const _fetchNetworkFilters = async () => {
      let url = `${process.env.REACT_APP_API_END_POINT}v2/location/get-provider/${domain}`;

      try {
        const response = await axios.get(url);
        if (response.status === 200) {
          let updatedNetworkArr = response.data.data;
          setNetworkFilter(updatedNetworkArr);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (!(networkFilters.length > 0)) _fetchNetworkFilters();
  }, []);

  const onChangeOtherIssue = (e) => {
    e.preventDefault();
    setReportIssueData({
      ...reportIssueData,
      message: e.target.value,
      otherIssue: true,
    });
  };

  const onSubmitReportIssue = async () => {
    const report = ["LOCATION", "DETAIL", "CARD", "CABLE", "OTHER"];
    let payload = {
      issue: report[reportIssueData.issue],
      category: reportIssueData.category,
      comment: reportIssueData.message,
      locationId: chargerData?._id ? chargerData._id : "",
      charge_box_id: chargerData?.name ? chargerData?.name : "",
    };
    const { data } = Token.parsedToken();
    if (data._id) {
      payload = { ...payload, user: data._id };
    }

    if (reportIssueData.otherIssue) {
      try {
        let baseUrl = `${process.env.REACT_APP_CHARGEMILES_CMS_END_POINT}/v1/charger/${chargerData?.name}/report`;
        let response = await axios(`${baseUrl}`, {
          method: "post",
          data: payload,
        });
        if (response.status) {
          setReportStat({
            open: true,
            variant: "success",
            message: "Report Submitted Successfully",
          });
          setReportIssueData({
            issue: "",
            message: "",
            otherIssue: false,
            category: "",
          });
        }
      } catch (error) {
        setReportStat({
          open: true,
          variant: "error",
          message: "Something went wrong",
        });
        console.log(error);
      }
    } else return;
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const getIcon = () => {
    let provider = networkFilters.filter(
      (network) => network.name === chargerData.provider
    );
    if (!provider)
      provider = networkFilters.filter((network) => network.name === "GENERIC");

    return (
      <img
        style={{ height: "30px", width: "30px" }}
        src={provider[0]?.icon}
        alt="Logo"
      />
    );
  };
  return (
    <Page
      title="Dashboard | Charger-UI"
      sx={{ marginTop: { xs: "128px", md: "62px", overflow: "hidden" } }}
    >
      <Container
        sx={{
          padding: {
            xs: "0",
            sm: "0",
            md: "50px 24px",
            lg: "50px 24px",
            xl: "50px 24px",
          },
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        style={{ maxWidth: "800px" }}
      >
        <Card sx={{ 
          pb: 3,
          boxShadow: (theme) => theme.customShadows?.z24 || '0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)',
          borderRadius: 3,
          overflow: "hidden"
        }}>
        {paymentStatus.isDone ? (
          <PaymentStatusContainer
            status={paymentStatus.status}
            message={paymentStatus.message}
            chargerId={chargerId}
            connectorId={connectorIdForStatus.current}
            email={email}
          />
        ) : (
          <>
            {isError && (
              <Alert
                variant="outlined"
                severity="error"
                sx={{ m: 2, color: "red" }}
              >
                {error?.response?.data?.message ??
                  "Some error occured while loading charger details"}
              </Alert>
            )}
              <Box
                sx={{
                  background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                  color: '#fff',
                  p: 3,
                  borderRadius: '12px 12px 0 0',
                  textAlign: 'center',
                }}
              >
                <Stack direction="row" alignItems="center" justifyContent="center" spacing={1.5} mb={1}>
                  {networkFilters && chargerData ? (
                    <Box sx={{ bgcolor: '#fff', borderRadius: '50%', p: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {getIcon()}
                    </Box>
                  ) : null}
                  <Typography variant="h6" fontWeight={700} color="inherit">
                    {!is.empty(charger)
                      ? !is.empty(charger.chargepoint_name)
                        ? charger.chargepoint_name
                        : "N/A"
                      : ""}
                  </Typography>
                </Stack>
                {!isError && (
                  <Typography variant="body2" color="rgba(255,255,255,0.85)" mb={1}>{`${
                    charger?.name ?? ""
                  } ${charger?.house_number ?? ""} ${
                    charger?.street ?? ""
                  }`}</Typography>
                )}
                <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    size="small"
                    disabled={
                      chargerData?.phone || chargerData?.alternatePhone
                        ? false
                        : true
                    }
                    disableRipple
                    sx={{
                      bgcolor: '#fff',
                      color: 'primary.main',
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      fontWeight: 600,
                      px: 2,
                      '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' },
                      '&.Mui-disabled': { color: 'rgba(0,0,0,0.26)', bgcolor: 'rgba(255,255,255,0.5)' },
                    }}
                  >
                    <Link
                      href={`tel: ${
                        chargerData?.phone
                          ? chargerData?.phone
                          : chargerData?.alternatePhone
                      }`}
                      color="inherit"
                      sx={{
                        display: "flex",
                        textDecoration: "none",
                        alignItems: "center",
                      }}
                    >
                      <Icon icon="eva:phone-call-outline" width={18} height={18} />
                      <Typography marginLeft={0.75} fontWeight={600} fontSize="0.8rem">Call Us</Typography>
                    </Link>
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setReportIssue(true)}
                    sx={{
                      borderColor: 'rgba(255,255,255,0.5)',
                      color: '#fff',
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      fontWeight: 600,
                      px: 2,
                      transition: 'all 0.2s ease',
                      '&:hover': { 
                        bgcolor: '#fff', 
                        borderColor: '#fff',
                        color: 'primary.main',
                        '& .MuiIcon-root': { color: 'primary.main' }
                      },
                    }}
                  >
                    <Icon icon="eva:alert-triangle-outline" width={18} height={18} style={{ marginRight: 6 }} />
                    <Typography fontWeight={600} fontSize="0.8rem">Report Issue</Typography>
                  </Button>
                </Stack>
              </Box>
            <Box sx={{ mb: 1 }} />
            <Box sx={{ px: 2 }}>
              <StyledChargerTabs
                value={value}
                onChange={handleChange}
                aria-label="icon tabs example"
                centered
              >
                <StyledChargerTab
                  icon={<Icon icon="eva:charging-outline" width={24} height={24} />}
                  aria-label="EV Station"
                  {...a11yProps(0)}
                />
                <StyledChargerTab
                  icon={<Icon icon="eva:info-outline" width={24} height={24} />}
                  aria-label="Information"
                  {...a11yProps(1)}
                />
                <StyledChargerTab
                  icon={<Icon icon="eva:message-circle-outline" width={24} height={24} />}
                  aria-label="Unknown Chat Box"
                  {...a11yProps(2)}
                />
                <StyledChargerTab
                  icon={<Icon icon="eva:image-outline" width={24} height={24} />}
                  aria-label="Photos"
                  {...a11yProps(3)}
                />
              </StyledChargerTabs>
            </Box>
            {!reportIssue && (
              <TabPanel
                value={value}
                index={0}
                className="tab-list tab-location"
              >
                <Box className="tabs-parent" sx={paymentStyles.tabParent}>
                  <Typography
                    variant="subtitle1"
                    textAlign="center"
                    mb={2}
                    fontWeight={600}
                  >
                    Select, Pay & Charge
                  </Typography>
                  <List
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: isSmallScreen ? "1rem" : "1.5rem",
                    }}
                  >
                    {charger &&
                      charger?.connectors?.map((item, i) => {
                        const itemStatus = charger.status?.toUpperCase() !== "A" ? "UNAVAILABLE" : item.status;
                        return (
                        <Fragment key={item.connector_id || i}>
                          {item && (
                            <ListItem
                              sx={{
                                padding: "0px",
                                cursor: "pointer",
                                ...(charger?.connectors?.length === 1 && {
                                  justifyContent: "center",
                                }),
                              }}
                              onClick={() =>
                                (itemStatus.toUpperCase() === "AVAILABLE" ||
                                itemStatus.toUpperCase() === "PREPARING"
                                  ? setConnector(item)
                                  : setConnector()) ||
                                (itemStatus.toUpperCase() === "AVAILABLE" ||
                                itemStatus.toUpperCase() === "PREPARING"
                                  ? setShowConnectorMsg(true)
                                  : setShowConnectorMsg(false))
                              }
                            >
                              <Paper
                                elevation={0}
                                sx={{
                                  width: "100%",
                                  borderRadius: "16px",
                                  border: "2px solid",
                                  borderColor: item.connector_id === connector?.connector_id ? "primary.main" : alpha(getStatusColor(itemStatus, theme), 0.5),
                                  boxShadow: item.connector_id === connector?.connector_id 
                                    ? `0 8px 24px ${alpha(theme.palette.primary.main, 0.16)}` 
                                    : '0 2px 8px rgba(145,158,171,0.12)',
                                  overflow: "hidden",
                                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                  backgroundColor: item.connector_id === connector?.connector_id ? alpha(theme.palette.primary.main, 0.04) : "#ffffff",
                                  display: 'flex',
                                  alignItems: 'stretch',
                                  minHeight: '92px',
                                  '&:hover': {
                                    boxShadow: item.connector_id !== connector?.connector_id ? '0 4px 12px rgba(145,158,171,0.16)' : '',
                                    transform: 'translateY(-2px)'
                                  }
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                    padding: '16px 20px',
                                    backgroundColor: item.connector_id === connector?.connector_id ? alpha(theme.palette.primary.main, 0.08) : alpha(getStatusColor(itemStatus, theme), 0.05),
                                    borderRight: `1px solid ${item.connector_id === connector?.connector_id ? alpha(theme.palette.primary.main, 0.2) : alpha(theme.palette.grey[500], 0.2)}`,
                                    '& svg, & img, & span svg': {
                                      width: '64px !important',
                                      height: '64px !important',
                                      fill: item.connector_id === connector?.connector_id ? theme.palette.primary.main : theme.palette.text.secondary,
                                      transition: 'all 0.3s ease',
                                      filter: item.connector_id === connector?.connector_id ? `drop-shadow(0px 4px 8px ${alpha(theme.palette.primary.main, 0.3)})` : 'none',
                                    }
                                  }}
                                >
                                  {item.connectorType ? (
                                    <span
                                      style={{ display: 'flex' }}
                                    >
                                      {
                                        socketTypeList.find(
                                          (socket) =>
                                            socket.value ===
                                            (item.connectorType === "null" || !item.connectorType
                                              ? "connector1"
                                              : item.connectorType)
                                        ).src
                                      }
                                    </span>
                                  ) : (
                                    getImage(imageMapper.FAULT_CONNECTOR_IMAGE)
                                  )}
                                </Box>

                                <Box sx={{ display: 'flex', flexGrow: 1, padding: '16px', alignItems: 'center', gap: '16px' }}>
                                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                    <Typography variant="subtitle1" fontWeight={700} color="text.primary" noWrap>
                                      {socketTypeList.find(
                                        (socket) =>
                                          socket.value ===
                                          (item.connectorType === "null" || !item.connectorType
                                            ? "connector1"
                                            : item.connectorType)
                                      ).type || "N/A"}
                                    </Typography>
                                    <Stack direction="column" alignItems="flex-start" spacing={0.25}>
                                      <Typography variant="body2" color="text.secondary" fontWeight={600}>
                                        {item.kw || "N/A"} KW
                                      </Typography>
                                      <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: '100%' }}>
                                        {item?.connectorName ? item.connectorName : item.connector_id}
                                      </Typography>
                                    </Stack>
                                  </Box>

                                  <Stack alignItems="flex-end" spacing={0.5} sx={{ minWidth: 80, flexShrink: 0 }}>
                                  <Typography variant="subtitle2" fontWeight={700} color="text.primary">
                                    {getPriceDisplay(item, domainConfig)}
                                  </Typography>
                                  <Box
                                    sx={{
                                      px: 1.5,
                                      py: 0.5,
                                      borderRadius: '6px',
                                      backgroundColor: alpha(getStatusColor(itemStatus, theme), 0.12),
                                      color: getStatusColor(itemStatus, theme),
                                      fontSize: '0.7rem',
                                      fontWeight: 700,
                                      textTransform: 'uppercase'
                                    }}
                                  >
                                    {itemStatus}
                                  </Box>
                                </Stack>
                              </Box>
                            </Paper>
                          </ListItem>
                          )}
                        </Fragment>
                      )})}
                    {charger &&
                      charger?.evses?.map((evse, i) => {
                        const evseStatus = charger.status?.toUpperCase() !== "A" ? "UNAVAILABLE" : evse.status;
                        return (
                        <ListItem
                          sx={{
                            padding: "0px",
                            flexDirection: "column",
                            cursor: "pointer",
                          }}
                          key={evse.evse_id || i}
                          onClick={() =>
                            evseStatus.toUpperCase() === "AVAILABLE" && setConnector(evse)
                          }
                          selected={connector?.uid === evse.uid}
                          disabled={evseStatus.toUpperCase() !== "AVAILABLE"}
                        >
                          <Paper
                            elevation={0}
                            sx={{
                              width: "100%",
                              borderRadius: "16px",
                              border: "2px solid",
                              borderColor: connector?.uid === evse.uid ? "primary.main" : alpha(getStatusColor(evseStatus, theme), 0.5),
                              boxShadow: connector?.uid === evse.uid 
                                ? `0 8px 24px ${alpha(theme.palette.primary.main, 0.16)}` 
                                : '0 2px 8px rgba(145,158,171,0.12)',
                              overflow: "hidden",
                              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              backgroundColor: connector?.uid === evse.uid ? alpha(theme.palette.primary.main, 0.04) : "#ffffff",
                              display: 'flex',
                              alignItems: 'stretch',
                              minHeight: '92px',
                              '&:hover': {
                                boxShadow: connector?.uid !== evse.uid ? '0 4px 12px rgba(145,158,171,0.16)' : '',
                                transform: 'translateY(-2px)'
                              }
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                padding: '16px 20px',
                                backgroundColor: evse.uid === connector?.uid ? alpha(theme.palette.primary.main, 0.08) : alpha(getStatusColor(evseStatus, theme), 0.05),
                                borderRight: `1px solid ${evse.uid === connector?.uid ? alpha(theme.palette.primary.main, 0.2) : alpha(theme.palette.grey[500], 0.2)}`,
                                '& svg, & img, & span svg': {
                                  width: '64px !important',
                                  height: '64px !important',
                                  fill: evse.uid === connector?.uid ? theme.palette.primary.main : theme.palette.text.secondary,
                                  transition: 'all 0.3s ease',
                                  filter: evse.uid === connector?.uid ? `drop-shadow(0px 4px 8px ${alpha(theme.palette.primary.main, 0.3)})` : 'none',
                                }
                              }}
                            >
                              <img
                                src={getImage(
                                  imageMapper.FAULT_CONNECTOR_IMAGE
                                )}
                                alt={"img"}
                              />
                            </Box>

                            <Box sx={{ display: 'flex', flexGrow: 1, padding: '16px', alignItems: 'center', gap: '16px' }}>
                              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                <Typography variant="subtitle1" fontWeight={700} color="text.primary" noWrap>
                                  Connector {evse.evse_id.slice(-2) || evse.evse_id}
                                </Typography>
                                <Stack direction="column" alignItems="flex-start" spacing={0.25}>
                                  <Typography variant="body2" color="text.secondary" fontWeight={600}>
                                    {`${(
                                      (1 *
                                        evse.connectors[0].voltage *
                                        evse.connectors[0].amperage) /
                                      1000
                                    ).toFixed(3) || "N/A"} KW`}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: '100%' }}>
                                    {evse.uid}
                                  </Typography>
                                </Stack>
                              </Box>

                              <Stack alignItems="flex-end" spacing={0.5} sx={{ minWidth: 80, flexShrink: 0 }}>
                              <Box
                                sx={{
                                  px: 1.5,
                                  py: 0.5,
                                  borderRadius: '6px',
                                  backgroundColor: alpha(getStatusColor(evseStatus, theme), 0.12),
                                  color: getStatusColor(evseStatus, theme),
                                  fontSize: '0.7rem',
                                  fontWeight: 700,
                                  textTransform: 'uppercase'
                                }}
                              >
                                {evseStatus}
                              </Box>
                            </Stack>
                          </Box>
                        </Paper>
                      </ListItem>
                      )})}
                    {((!charger && isFetching) || isError) && (
                      <React.Fragment>
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            ...paymentStyles.listItemPaper,
                            height: "90px",
                            borderRadius: "16px",
                          }}
                        />
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            ...paymentStyles.listItemPaper,
                            height: "90px",
                            borderRadius: "16px",
                          }}
                        />
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            ...paymentStyles.listItemPaper,
                            height: "90px",
                            borderRadius: "16px",
                          }}
                        />
                      </React.Fragment>
                    )}
                  </List>
                  {showConnectorMsg && (
                    <Typography sx={{ mt: 2, color: "#E84037" }}>
                      Note - Please connect charging gun to the EV.
                    </Typography>
                  )}
                </Box>
              </TabPanel>
            )}

            {reportIssue && (
              <Box className="tabs-parent" sx={paymentStyles.tabParent}>
                <Stack direction="row" mb={2}>
                  <Icon
                    icon={redirectFill}
                    width={24}
                    height={24}
                    onClick={() => setReportIssue(false)}
                  />
                  <Typography component="h3" sx={{ width: "100%" }}>
                    Report an issue
                  </Typography>
                </Stack>
                <Typography>
                  Please select an issue that you've encountered:
                </Typography>
                <Stack
                  direction="column"
                  spacing={1.6}
                  sx={{
                    margin: isSmallScreen ? "1rem 1rem 0" : "1rem 2rem 0",
                    placeItems: "center",
                  }}
                >
                  {reportIssuesList.map((list, index) => {
                    return (
                      <IssueButton
                        key={list.id}
                        variant="outlined"
                        className={
                          reportIssueData.issue === index
                            ? "selected_report_issue"
                            : ""
                        }
                        sx={{ background: "#fff", textTransform: "capitalize" }}
                        onClick={() =>
                          setReportIssueData({
                            issue: index,
                            otherIssue: true,
                            category: list.text,
                          })
                        }
                      >
                        {list.text}
                      </IssueButton>
                    );
                  })}
                  <IssueButton
                    variant="outlined"
                    className={
                      reportIssueData.issue === 4 ? "selected_report_issue" : ""
                    }
                    sx={{ background: "#fff", textTransform: "capitalize" }}
                    onClick={() =>
                      setReportIssueData({
                        issue: 4,
                        otherIssue: true,
                        category: "Other",
                      })
                    }
                  >
                    Other
                  </IssueButton>
                  {reportIssueData.otherIssue && (
                    <Paper
                      sx={{ padding: "1rem" }}
                      component="div"
                      elevation={0}
                      variant="outlined"
                      square
                    >
                      <Typography variant="body2" mb={1}>
                        {Constant.label.ISSUE_PARA}
                      </Typography>
                      <TextField
                        id="others-issue"
                        placeholder="Placeholder"
                        value={reportIssueData.message}
                        multiline
                        rows={3}
                        fullWidth
                        onChange={(e) => onChangeOtherIssue(e)}
                        // sx={styles.textArea}
                      />
                    </Paper>
                  )}
                  <IssueButton
                    variant="contained"
                    color="primary"
                    onClick={() => onSubmitReportIssue()}
                  >
                    SUBMIT
                  </IssueButton>
                </Stack>
              </Box>
            )}

            {!reportIssue && (
              <TabPanel value={value} index={1} className="tab-list tab-info">
                <Box>
                  <MarkerInformationTab
                    locationDetail={chargerData}
                    forLocationTab={false}
                  />
                </Box>
              </TabPanel>
            )}
            {!reportIssue && (
              <TabPanel value={value} index={2} className="tab-list tab-info">
                <Box className="tabs-parent" sx={paymentStyles.tabParent}>
                  <Typography
                    variant="subtitle1"
                    textAlign="center"
                    mb={2}
                    fontWeight={600}
                  >
                    FAQs:
                  </Typography>

                  {(!faqData || faqData.filter(faq => faq.question && faq.question.trim().length > 0).length === 0) ? (
                    <Box sx={{ py: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.6 }}>
                      <LiveHelpOutlinedIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
                      <Typography variant="subtitle1" color="text.secondary">
                        No FAQs Provided
                      </Typography>
                    </Box>
                  ) : (
                    faqData.filter(faq => faq.question && faq.question.trim().length > 0).map((faqs, index) => {
                      return (
                        <Accordion
                          key={faqs.id}
                          sx={{ marginBottom: "1rem" }}
                          className="accordion_content"
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography textAlign="left">
                              Q-{index + 1}: {faqs.question}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography textAlign="left">
                              Ans-{index + 1}: {faqs.answer}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  )}
                </Box>
              </TabPanel>
            )}
            {!reportIssue && (
              <TabPanel value={value} index={3} className="tab-list tab-info">
                <Box className="tabs-parent" sx={paymentStyles.tabParent}>
                  <Typography
                    variant="subtitle1"
                    textAlign="center"
                    mb={2}
                    fontWeight={600}
                  >
                    Photos:
                  </Typography>
                  {(!chargerData?.photos || chargerData.photos.length === 0) ? (
                    <Box sx={{ py: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.6 }}>
                      <PhotoLibraryOutlinedIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
                      <Typography variant="subtitle1" color="text.secondary">
                        No Photos Provided
                      </Typography>
                    </Box>
                  ) : (
                    <ImageList cols={3} rowHeight={100} gap={16}>
                      {chargerData.photos.map((photo, index) => (
                        <ImageListItem key={index}>
                          <img
                            src={photo}
                            alt="Feedback Img"
                            onClick={() => {
                              setPhotoModal({ open: true, src: photo });
                            }}
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  )}
                  <Dialog
                    onClose={() => {
                      setPhotoModal({ open: false, src: "" });
                    }}
                    aria-labelledby="customized-dialog-title"
                    open={photoModal.open}
                  >
                    <Tooltip title="Close Photo" placement="bottom">
                    <IconButton
                      aria-label="close"
                      onClick={() => {
                        setPhotoModal({ open: false, src: "" });
                      }}
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                    </Tooltip>
                    <DialogContent
                      sx={{
                        minHeight: "300px",
                        minWidth: isSmallScreen ? "100%" : "600px",
                        display: "flex",
                        placeItems: "center",
                        placeContent: "center",
                        padding: isSmallScreen ? "30px 16px" : "32px 40px",
                      }}
                    >
                      <img src={photoModal.src} alt="Review" />
                    </DialogContent>
                  </Dialog>
                </Box>
              </TabPanel>
            )}

            {!isGuest &&
              (!!charger?.pay_with_card || !!charger?.employee_or_resident) && (
                <EmailComponent
                  connector={connector}
                  email={email}
                  setEmail={setEmail}
                  // customerName = {customerName}
                  // setCustomerName= {setCustomerName}
                  chargerId={chargerId}
                  setPaymentStatus={setPaymentStatus}
                  setGuest={setGuest}
                  payWithCard={!!charger?.pay_with_card}
                  employeeOrResident={!!charger?.employee_or_resident}
                />
              )}
            {isGuest && !reportIssue && email && value === 0 && (
              <PaymentForm
                clientHandler={clientHandler}
                chargerId={chargerId}
                email={email}
                companyId={charger.companyId}
                domain={charger?.domain}
                // customerName={customerName}
                connector={connector}
                submitHandler={setPaymentStatus}
                paymentMethod={{
                  keyId: charger?.key_id,
                  id: charger?.payment_gateway_id,
                }}
              />
            )}
            {showCardInfo && clientId && (
              <Box
                className="tabs-parent"
                sx={{
                  ...paymentStyles.tabParent,
                }}
              >
                <StripeCheckout
                  clientId={clientId}
                  submitHandler={setPaymentStatus}
                  keyId={charger?.key_id}
                  chargerId={chargerId}
                  connectorId={
                    !is.empty(connector?.ocpi_connector_id)
                      ? connector?.ocpi_connector_id
                      : connector?.connector_id
                  }
                  email={email}
                />
              </Box>
            )}
          </>
        )}
        </Card>
      </Container>

      <MuiSnackBar
        open={reportStat.open}
        severity={reportStat.variant}
        message={reportStat.message}
        onCloseFunc={() =>
          setReportStat((messageOp) => ({ ...messageOp, open: false }))
        }
      />
    </Page>
  );
};
